// Sales Velocity → Workspace task for the customer's AM, linked to the customer (AM is notified on assign).
import { useEffect, useState } from "react";
import TaskDrawer from "../../workspace/panels/TaskDrawer";
import { workspaceApi } from "../../workspace/_shared";
import { gbp, vDate } from "./_shared";

export const followUpContext = (r) => [
  `Sales Velocity: ${r.Status || "—"}${r.ValueBand ? ` · ${r.ValueBand} value` : ""}`,
  `Last order ${vDate(r.LastOrderDate)}${r.DaysSinceLast != null ? ` (${r.DaysSinceLast}d ago)` : ""}`,
  r.Spend90 != null ? `Spend 90d ${gbp(r.Spend90)} · 12m ${gbp(r.Spend12m)}` : `Lifetime ${gbp(r.SpendLifetime)} over ${r.OrdersLifetime || 0} orders`,
].join("\n");

const plusDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };

export default function VelocityTaskPopup({ r, onClose }) {
  const [dir, setDir] = useState(null);
  useEffect(() => {
    Promise.all([workspaceApi.listUsers(), workspaceApi.listTeams("all")])
      .then(([u, t]) => setDir({ users: u || [], teams: t.items || [] })).catch(() => setDir({ users: [], teams: [] }));
  }, []);
  if (!dir) return null;
  const amUser = r.am ? dir.users.find((u) => (u.name || "").toLowerCase() === r.am.toLowerCase()) : null;
  const defaults = {
    title: `Follow up ${r.name}${r.Status ? ` (${r.Status})` : ""}`,
    description: followUpContext(r),
    assignee_id: amUser?.id || null,
    due_date: plusDays(r.Status === "Cooling" || r.Status === "Active" ? 3 : 7),
    linked_entities: [{ type: "person", id: r.id, label: r.name }],
  };
  return (
    <TaskDrawer open taskId={null} createDefaults={defaults} users={dir.users} teams={dir.teams} onClose={onClose}
      onSaved={onClose} />
  );
}
